class CustomPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.overlay = this.querySelector(".overlay");
    if (this.overlay && this.overlay.parentElement !== document.body) {
      document.body.appendChild(this.overlay);
    }
    this.setupEventListeners();
  }

  setupEventListeners() {
    const triggers = this.querySelectorAll('[data-open-popup="btnOpen"]');
    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => this.open());
    });

    if (this.overlay) {
      const closeButtons = this.overlay.querySelectorAll('[data-button-close="close"]');
      closeButtons.forEach((closeBtn) => {
        closeBtn.addEventListener("click", () => this.close());
      });

      this.overlay.addEventListener("click", (e) => {
        if (e.target === this.overlay) this.close();
      });
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.overlay && this.overlay.classList.contains("show")) {
        this.close();
      }
    });
  }

  open() {
    if (this.overlay) {
      this.overlay.classList.add("show");
      document.body.style.overflow = "hidden";
    }
  }

  close() {
    if (this.overlay) {
      this.overlay.classList.remove("show");
      document.body.style.overflow = "";
    }
  }

  disconnectedCallback() {
    if (this.overlay && this.overlay.parentElement === document.body) {
      this.overlay.remove();
    }
  }
}

customElements.define("custom-popup", CustomPopup);

